import React, { useState, useEffect, useRef, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { Modal } from 'react-bootstrap';
import { urlApiProd } from '../utiles';
import DateInput from '../../components/DateInput/DateInput';
import AgregarProducto from '../productos/AgregarProducto';

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = date.getUTCDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const EditarProforma = ({ proforma, clientes, subclientes, incoterms, puertos, productos, documentos, usuarios, categorias, especies, medidas, calidades, pt, guardar, cerrar }) => {
    const clienteInicial = clientes.find(c => parseInt(c.id_cliente, 10) === parseInt(proforma.cliente, 10));
    const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
    const [fecha, setFecha] = useState(proforma.fecha ? formatDate(proforma.fecha) : null);
    const [cliente, setCliente] = useState(proforma.cliente || 0);
    const [fecha_embarque, setFechaEmbarque] = useState(proforma.fecha_embarque ? formatDate(proforma.fecha_embarque) : null);
    const [po, setPo] = useState(proforma.po || '');
    const [hc, setHc] = useState(proforma.hc || '');
    const [payment_terms, setPaymentTerms] = useState(proforma.payment_terms || 0);
    const [shipping_line, setShippingLine] = useState(proforma.shipping_line || '');
    const [incoterm, setIncoTerm] = useState(proforma.incoterm || 0);
    const [puerto, setPuerto] = useState(proforma.puerto || 0);
    const [direccion_despacho, setDireccionDespacho] = useState(proforma.direccion_despacho || clienteInicial?.direccion_despacho || '');
    const [direccion_destino, setDireccionDestino] = useState(proforma.direccion_destino || '');
    const [descripcion_producto, setDescripcionProducto] = useState(proforma.descripcion_producto || '');
    const [Productos, setProductos] = useState(
        proforma.productos.map((producto, index) => ({
            id_producto: producto || 0,
            calidad: proforma.calidad[index] || 0,
            real_size: proforma.real_size[index] || '',
            m3: proforma.m3[index] || 0,
            usd_m3: proforma.usd_m3[index] || 0,
            usd_total: proforma.usd_total[index] || 0
        }))
    );
    const [valor_proforma, setValorProforma] = useState(proforma.valor_proforma || 0);
    const [bank_information, setBankInformation] = useState(proforma.bank_information || '');
    const [beneficiary_bank, setBeneficiaryBank] = useState(proforma.beneficiary_bank || '');
    const [quality_standards, setQualityStandards] = useState(proforma.quality_standards || '');
    const [documentosRequeridos, SetDocumentosRequeridos] = useState(proforma.documentos || []);
    const [estado, setEstado] = useState(proforma.estado || 0);
    const [remitente, setRemitente] = useState(proforma.remitente || 0);
    const [aprobador, setAprobador] = useState(proforma.aprobador || 0);
    const [observaciones_proforma, setObservacionesProforma] = useState(proforma.observaciones_proforma || '');
    const [observaciones_adicionales, setObservacionesAdicionales] = useState(proforma.observaciones_adicionales || '');
    const [nuevoDocumento, setNuevoDocumento] = useState(null);
    const [productosCliente, setProductosCliente] = useState([]);
    const [especificaciones_lc, setEspecificacionesLC] = useState(proforma.especificaciones_lc || '');
    const [indicador1, setIndicador1] = useState(false);
    const [indicador2, setIndicador2] = useState(false);
    const [indicador3, setIndicador3] = useState(false);
    const [indicador4, setIndicador4] = useState(false);
    const [advance, setAdvance] = useState(proforma.advance || 0);
    const [cad, setCAD] = useState(proforma.cad || 0);
    const [productoSeleccionado, setProductoSeleccionado] = useState(null);
    const [productosDisponibles, setProductosDisponibles] = useState([]);
    const [productNames, setProductNames] = useState([]);
    const [productSearchTerm, setProductSearchTerm] = useState('');
    const [showProductSearchDropdown, setShowProductSearchDropdown] = useState(false);
    const productSearchDropdownRef = useRef(null);
    const [showAgregarProducto, setShowAgregarProducto] = useState(false);
    const [idsProductoExtra, setIdsProductoExtra] = useState([]);
    const [indicadorIT, setIndicadorIT] = useState(null)
    const [origen, setOrigen] = useState(proforma.origen || 'Brazil');
    const [moneda, setMoneda] = useState(proforma.moneda || 0);
    const [allowance, setAllowance] = useState(proforma.allowance || 0);
    const [esBorrador, setEsBorrador] = useState(false);
    const [m3, setM3] = useState('');
    const [usd_m3, setUsdM3] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [productoEnEdicion, setProductoEnEdicion] = useState(null);
    const [correlativo, setCorrelativo] = useState(proforma.correlativo || 0);
    const [id_pi, setIdPi] = useState(proforma.id_pi || '');
    const [empresaEmisor, setEmpresaEmisor] = useState(proforma.empresa_emisor || '');


    useEffect(() => {
        const clienteEncontrado = clientes.find(c => parseInt(c.id_cliente, 10) === parseInt(cliente, 10));
        if (clienteEncontrado) {
            setProductosCliente(clienteEncontrado.productos || []);
        } else {
            setProductosCliente([]);
        }
        setIdsProductoExtra([]);
    }, [cliente, clientes]);

    const productIdsPermitidos = useMemo(() => {
        const base =
            productosCliente && productosCliente.length
                ? productosCliente.map((x) => parseInt(x, 10))
                : (productos || []).map((p) => parseInt(p.id_producto, 10));
        const extra = idsProductoExtra.map((x) => parseInt(x, 10));
        return [...new Set([...base, ...extra])];
    }, [productosCliente, productos, idsProductoExtra]);

    const idProductoPermitidoParaProforma = (idProducto) => {
        const id = parseInt(idProducto, 10);
        if (!id) return false;
        const enDisponibles = productosDisponibles.some((p) => parseInt(p.id_producto, 10) === id);
        if (!enDisponibles) return false;
        if (!productIdsPermitidos || productIdsPermitidos.length === 0) return true;
        return productIdsPermitidos.some((r) => parseInt(r, 10) === id);
    };

    const normalizarTextoBusqueda = (s) => (s || '').toLowerCase().trim().replace(/\s+/g, ' ');
    const coincideBusquedaProducto = (texto, termNormalizado) => {
        if (!termNormalizado) return true;
        const t = texto;
        if (t.includes(termNormalizado)) return true;
        const tokens = termNormalizado.split(' ').filter(Boolean);
        if (tokens.length <= 1) return false;
        return tokens.every((tok) => t.includes(tok));
    };
    const nombreProductosFiltrados = productNames.filter((p) => {
        if (!idProductoPermitidoParaProforma(p.id_producto)) return false;
        const term = normalizarTextoBusqueda(productSearchTerm);
        if (!term) return true;
        const nombre = normalizarTextoBusqueda(p.nombre_producto || '');
        const cal = normalizarTextoBusqueda(p.calidad || '');
        return coincideBusquedaProducto(nombre, term) || coincideBusquedaProducto(cal, term);
    });

    const fetchProductNames = async () => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${urlApiProd}/nombreproductos_ordencompra`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            if (response.ok) {
                const data = await response.json();
                const uniqueProducts = [];
                const seenIds = new Set();
                data.forEach((item) => {
                    const id = item.id_producto;
                    if (id != null && id !== '' && !seenIds.has(Number(id))) {
                        seenIds.add(Number(id));
                        uniqueProducts.push(item);
                    }
                });
                setProductNames(uniqueProducts);
                return uniqueProducts;
            }
        } catch (error) {
            console.error('Error al obtener nombres de productos:', error);
        }
        return [];
    };

    useEffect(() => {
        fetchProductNames();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (productSearchDropdownRef.current && !productSearchDropdownRef.current.contains(event.target)) {
                setShowProductSearchDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (productos && productos.length) {
            setProductosDisponibles(productos);
        }
    }, [productos]);

    useEffect(() => {
        if (!editMode || !productoSeleccionado) return;
        const m = productNames.find(
            (n) => parseInt(n.id_producto, 10) === parseInt(productoSeleccionado, 10)
        );
        if (m) setProductSearchTerm(m.nombre_producto);
    }, [editMode, productoSeleccionado, productNames]);

    useEffect(() => {
        if (payment_terms) {
            seleccionPT(payment_terms);
        }
    }, [payment_terms]);

    useEffect(() => {
        if (incoterm) {
            seleccionIT(incoterm);
        }
    }, [incoterm]);

    const getCurrencySymbol = (moneda) => {
        switch (moneda) {
            case 0: return 'USD';
            case 1: return 'EUR';
            case 2: return 'CLP';
            case 3: return 'BRL';
            case 4: return 'PYG';
            default: return 'USD';
        }
    };

    const handleSubmit = (event, borrador) => {
        event.preventDefault();
        setBotonDeshabilitado(true);

        let nuevoEstado = estado;

        if (borrador) {
            nuevoEstado = 0;
        } else {
            if (estado === 0) {
                nuevoEstado = 2;
            }
        }

        const arrayProductos = [];
        const arrayRealSize = [];
        const arrayM3 = [];
        const arrayUSDM3 = [];
        const arrayUSDTotal = [];
        const arrayCalidad = [];

        Productos.forEach(producto => {
            arrayProductos.push(producto.id_producto)
            arrayCalidad.push(producto.calidad)
            arrayRealSize.push(producto.real_size)
            arrayM3.push(producto.m3)
            arrayUSDM3.push(producto.usd_m3)
            arrayUSDTotal.push(producto.usd_total)
        })

        const calidadPlano = arrayCalidad.flat();

        const arrayDocumentos = []

        documentosRequeridos.forEach(doc => {
            arrayDocumentos.push(doc)
        })

        if (!parseInt(hc, 10) || parseInt(hc, 10) <= 0) {
            alert('Ingrese el HC (cantidad de contenedores High Cube).');
            return;
        }

        const edited = {
            id_proforma: proforma.id_proforma,
            fecha,
            cliente: parseInt(cliente),
            fecha_embarque,
            payment_terms,
            shipping_line,
            incoterm,
            direccion_despacho,
            puerto,
            direccion_destino,
            descripcion_producto,
            productos: arrayProductos,
            real_size: arrayRealSize,
            m3: arrayM3,
            usd_m3: arrayUSDM3,
            usd_total: arrayUSDTotal,
            valor_proforma,
            bank_information,
            beneficiary_bank,
            quality_standards,
            documentos: arrayDocumentos,
            estado: nuevoEstado,
            remitente: parseInt(remitente),
            aprobador: parseInt(aprobador),
            observaciones_proforma,
            observaciones_adicionales,
            especificaciones_lc,
            advance,
            cad,
            calidad: calidadPlano,
            origen,
            moneda,
            allowance,
            correlativo,
            id_pi,
            po: po.trim(),
            hc: parseInt(hc, 10),
            empresa_emisor: parseInt(empresaEmisor)
        }

        guardar(edited);
        cerrar();
    }

    const columnsProductos = [
        {
            name: 'Producto',
            selector: row => {
                if (!row.id_producto) return '';
                const productoEncontrado =
                    productos.find((prod) => parseInt(prod.id_producto, 10) === parseInt(row.id_producto, 10)) ||
                    productosDisponibles.find((prod) => parseInt(prod.id_producto, 10) === parseInt(row.id_producto, 10));
                if (productoEncontrado) {
                    const categoriaEncontrada = categorias.find(
                        (categoria) => parseInt(categoria.id_categoria, 10) === parseInt(productoEncontrado.categoria, 10)
                    );
                    const especieEncontrada = especies.find(
                        (especie) => parseInt(especie.id_especie, 10) === parseInt(productoEncontrado.especie, 10)
                    );
                    const medidaEncontrada = medidas.find(
                        (medida) => parseInt(medida.id_medida, 10) === parseInt(productoEncontrado.medida, 10)
                    );
                    if (categoriaEncontrada && especieEncontrada && medidaEncontrada) {
                        const espMostrar = productoEncontrado.espesor;
                        return (
                            categoriaEncontrada.nombre +
                            ' de ' +
                            especieEncontrada.nombre +
                            ' ' +
                            espMostrar +
                            ' X ' +
                            medidaEncontrada.ancho +
                            ' X ' +
                            medidaEncontrada.largo
                        );
                    }
                }
                const nomOc = productNames.find(
                    (n) => parseInt(n.id_producto, 10) === parseInt(row.id_producto, 10)
                );
                return nomOc?.nombre_producto || '';
            },
        },
        {
            name: 'Calidad',
            selector: row => {
                if (row.calidad) {
                    const calidadEncontrada = calidades.find(c => parseInt(c.id_calidad, 10) === parseInt(row.calidad, 10));
                    if (calidadEncontrada) {
                        return calidadEncontrada.calidad;
                    }
                }
                return row.calidad || '';
            },
            width: '15%',
        },
        {
            name: 'Real Size',
            selector: row => row.real_size,
            width: '15%',
        },
        {
            name: 'm3',
            selector: row => row.m3,
            width: '15%',
        },
        {
            name: `${getCurrencySymbol(moneda)}/m3`,
            selector: row => row.usd_m3,
            width: '15%',
        },
        {
            name: `Total ${getCurrencySymbol(moneda)}`,
            selector: row => row.usd_total,
            width: '15%',
        },
        {
            name: 'Editar',
            cell: row => (
                <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => handleEditProducto(row)}
                >
                    Editar
                </button>
            ),
            ignoreRowClick: true,
            width: '100px',
        },
        {
            name: 'Eliminar',
            cell: row => (
                <div className="delete-button-container">
                    <button
                        type="button"
                        className="btn btn-outline-danger delete-button"
                        onClick={() => {
                            if (window.confirm('¿Estás seguro?')) {
                                handleDeleteProducto(row.id_producto, row.calidad);
                            }
                        }}
                    >
                        X
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            width: '100px',
        },
    ];

    const columnsDocumentos = [
        {
            name: 'Documentos',
            selector: row => {
                if (row) {
                    const docEncontrado = documentos.find(d => parseInt(d.id_documento) === parseInt(row));
                    if (docEncontrado) {
                        return docEncontrado.nombre
                    }
                }
            },
        },
        {
            name: 'Eliminar',
            cell: row => (
                <div className="delete-button-container">
                    <button
                        type="button"
                        className="btn btn-outline-danger delete-button"
                        onClick={() => {
                            if (window.confirm('¿Estás seguro?')) {
                                handleDeleteDocumento(row)
                            }
                        }}
                    >
                        X
                    </button>
                </div>
            ),
            ignoreRowClick: true,
            width: '100px',
        },
    ];

    const handleDeleteProducto = (id_producto, calidadRow) => {
        const updatedProductos = Productos.filter(
            (producto) =>
                !(parseInt(producto.id_producto, 10) === parseInt(id_producto, 10) &&
                    String(producto.calidad) === String(calidadRow))
        );
        if (updatedProductos.length !== Productos.length) {
            setProductos(updatedProductos);
            if (updatedProductos.length === 0) {
                setDescripcionProducto('');
            }
        }
    };

    const handleAgregarProducto = () => {
        if (productoSeleccionado) {
            const producto = productosDisponibles.find(
                (prod) => parseInt(prod.id_producto, 10) === parseInt(productoSeleccionado, 10)
            );

            if (producto) {
                if (!m3 || !usd_m3) {
                    alert('Por favor ingrese todos los detalles requeridos (m3, Precio).');
                    return;
                }

                if (editMode && productoEnEdicion) {
                    const updatedProductos = Productos.map((prod) => {
                        if (
                            prod.id_producto === productoEnEdicion.id_producto &&
                            String(prod.calidad) === String(productoEnEdicion.calidad)
                        ) {
                            return {
                                ...prod,
                                m3: parseFloat(parseFloat(m3).toFixed(3)),
                                usd_m3: parseFloat(parseFloat(usd_m3).toFixed(3)),
                                usd_total: parseFloat((parseFloat(m3) * parseFloat(usd_m3)).toFixed(3)),
                            };
                        }
                        return prod;
                    });
                    setProductos(updatedProductos);
                    setEditMode(false);
                    setProductoEnEdicion(null);
                    setM3('');
                    setUsdM3('');
                    setProductoSeleccionado(null);
                    setProductSearchTerm('');
                    alert('Producto actualizado exitosamente.');
                } else {
                    const categoriaSeleccionada = categorias.find(
                        (categoria) => parseInt(categoria.id_categoria, 10) === parseInt(producto.categoria, 10)
                    );
                    const especieSeleccionada = especies.find(
                        (especie) => parseInt(especie.id_especie, 10) === parseInt(producto.especie, 10)
                    );
                    const medidaEncontrada = medidas.find((m) => m.id_medida === producto.medida);

                    if (medidaEncontrada && categoriaSeleccionada && especieSeleccionada) {
                        const indiceEspesor = medidaEncontrada.espesor.findIndex((e) => e === producto.espesor);

                        if (indiceEspesor !== -1) {
                            const espesorrCorrespondiente = medidaEncontrada.espesorr[indiceEspesor];

                            const productoCumpleRestricciones = Productos.every((line) => {
                                const productoExistente =
                                    productosDisponibles.find(
                                        (prod) => parseInt(prod.id_producto, 10) === parseInt(line.id_producto, 10)
                                    ) ||
                                    productos.find(
                                        (prod) => parseInt(prod.id_producto, 10) === parseInt(line.id_producto, 10)
                                    );
                                if (!productoExistente) return true;
                                const categoriaExistente = categorias.find(
                                    (categoria) => parseInt(categoria.id_categoria, 10) === parseInt(productoExistente.categoria, 10)
                                );
                                const especieExistente = especies.find(
                                    (especie) => parseInt(especie.id_especie, 10) === parseInt(productoExistente.especie, 10)
                                );
                                if (!categoriaExistente || !especieExistente) return true;
                                return (
                                    parseInt(categoriaExistente.id_categoria, 10) ===
                                        parseInt(categoriaSeleccionada.id_categoria, 10) &&
                                    parseInt(especieExistente.id_especie, 10) === parseInt(especieSeleccionada.id_especie, 10)
                                );
                            });

                            if (!productoCumpleRestricciones) {
                                alert('No se pueden agregar productos de diferentes categorías o especies.');
                                return;
                            }

                            const nuevo = {
                                id_producto: parseInt(producto.id_producto, 10),
                                real_size: `${espesorrCorrespondiente} x ${medidaEncontrada.anchor} x ${medidaEncontrada.largor}`,
                                m3: parseFloat(parseFloat(m3).toFixed(3)),
                                usd_m3: parseFloat(parseFloat(usd_m3).toFixed(3)),
                                usd_total: parseFloat((parseFloat(m3) * parseFloat(usd_m3)).toFixed(3)),
                                calidad: parseInt(producto.id_calidad, 10),
                            };

                            setProductos([...Productos, nuevo]);
                            setDescripcionProducto(
                                `${especieSeleccionada.nombre_ingles} ${categoriaSeleccionada.nombre_ingles}`
                            );
                            setM3('');
                            setUsdM3('');
                            alert('Producto Agregado');
                        } else {
                            alert('El espesor seleccionado no coincide con ningún espesorr disponible.');
                        }
                    } else {
                        alert('Medida no encontrada.');
                    }
                }
            } else {
                alert('Debe seleccionar un producto.');
            }
        } else {
            alert('Producto no seleccionado.');
        }
    };

    useEffect(() => {
        if (!editMode) {
            setM3('');
            setUsdM3('');
        }
    }, [productoSeleccionado, editMode]);

    useEffect(() => {
        const totalUSD = Productos.reduce((acc, producto) => acc + parseFloat(producto.usd_total || 0), 0);
        setValorProforma(totalUSD);
    }, [Productos]);


    const handleDeleteDocumento = (id) => {
        const updatedDocumentos = documentosRequeridos.filter((doc) => doc !== id);
        SetDocumentosRequeridos(updatedDocumentos);
    };

    const handleAgregarDocumento = () => {
        if (nuevoDocumento) {
            const documentoSeleccionado = documentos.find(d => parseInt(d.id_documento) === parseInt(nuevoDocumento));
            if (documentoSeleccionado) {
                SetDocumentosRequeridos([...documentosRequeridos, documentoSeleccionado.id_documento]);
                setNuevoDocumento(null);
            } else {
                alert("No se puede agregar el documento seleccionado.");
            }
        }
    };

    const seleccionPT = (paymentterm) => {
        if (paymentterm !== 0) {
            const ptSeleccionado = pt.find(payment => payment.id_paymentterm === parseInt(paymentterm));
            if (ptSeleccionado) {
                setIndicador1(ptSeleccionado.reglas.includes(1));
                setIndicador2(ptSeleccionado.reglas.includes(2));
                setIndicador3(ptSeleccionado.reglas.includes(3));
                setIndicador4(ptSeleccionado.reglas.includes(4));
                setPaymentTerms(parseInt(paymentterm));
            }
        }
    };

    const seleccionIT = (incoterm) => {
        if (incoterm !== 0) {
            const itSeleccionado = incoterms.find(i => i.id_incoterm === parseInt(incoterm));
            if (itSeleccionado) {
                setIncoTerm(itSeleccionado.id_incoterm);
                setIndicadorIT(itSeleccionado.indicador);
            } else {
                console.log("No se encontró el IncoTerm seleccionado.");
            }
        }
    };



    const handleEditProducto = (producto) => {
        setProductoSeleccionado(producto.id_producto);
        setM3(producto.m3);
        setUsdM3(producto.usd_m3);
        setEditMode(true);
        setProductoEnEdicion(producto);
        const np = productNames.find(
            (n) => parseInt(n.id_producto, 10) === parseInt(producto.id_producto, 10)
        );
        if (np) setProductSearchTerm(np.nombre_producto);
    };


    return (
        <div className='modal-overlay'>
            <div className='modal1'>
                <div className='card'>
                    <form onSubmit={handleSubmit}>
                        <div className='card-header'>
                            <div className='card-title' style={{ textAlign: 'center' }}>
                                <strong>
                                    Editar Proforma Invoice {proforma.id_pi ? proforma.id_pi : (
                                        `${clientes.find(c => c.id_cliente === parseInt(cliente))?.siglas} ${correlativo < 10 ? '0' + correlativo : correlativo}-${isNaN(new Date(proforma.fecha_embarque).getUTCFullYear())
                                            ? '00'
                                            : new Date(proforma.fecha_embarque).getUTCFullYear().toString().substr(-2)}`
                                    )}
                                </strong>
                            </div>
                        </div>
                        <div className='card-body'>
                            <div className="input-group mb-3">
                                <span className='input-group-text'>Moneda</span>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="moneda"
                                        id="usd"
                                        value={0}
                                        checked={moneda === 0}
                                        onChange={(e) => setMoneda(parseInt(e.target.value))}
                                    />
                                    <label className="form-check-label" htmlFor="usd">USD</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="moneda"
                                        id="eur"
                                        value={1}
                                        checked={moneda === 1}
                                        onChange={(e) => setMoneda(parseInt(e.target.value))}
                                    />
                                    <label className="form-check-label" htmlFor="eur">EUR</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="moneda"
                                        id="clp"
                                        value={2}
                                        checked={moneda === 2}
                                        onChange={(e) => setMoneda(parseInt(e.target.value))}
                                    />
                                    <label className="form-check-label" htmlFor="clp">CLP</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="moneda"
                                        id="brl"
                                        value={3}
                                        checked={moneda === 3}
                                        onChange={(e) => setMoneda(parseInt(e.target.value))}
                                    />
                                    <label className="form-check-label" htmlFor="brl">BRL</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="moneda"
                                        id="pyg"
                                        value={4}
                                        checked={moneda === 4}
                                        onChange={(e) => setMoneda(parseInt(e.target.value))}
                                    />
                                    <label className="form-check-label" htmlFor="pyg">PYG</label>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <span className='input-group-text'>Empresa Emisor</span>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="empresaEmisor"
                                        id="ptc"
                                        value={0}
                                        checked={empresaEmisor === 0}
                                        onChange={(e) => setEmpresaEmisor(parseInt(e.target.value))}
                                    />
                                    <label className="form-check-label" htmlFor="ptc">PTC</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="empresaEmisor"
                                        id="ptb"
                                        value={1}
                                        checked={empresaEmisor === 1}
                                        onChange={(e) => setEmpresaEmisor(parseInt(e.target.value))}
                                    />
                                    <label className="form-check-label" htmlFor="ptb">PTB</label>
                                </div>
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Fecha de Emisión</span>
                                <DateInput
                                    value={fecha}
                                    onChange={(e) => setFecha(e.target.value)}
                                />
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text">Cliente</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={
                                        cliente ? clientes.find(c => c.id_cliente === cliente)?.nombre : ''
                                    }
                                    disabled
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Fecha Embarque</span>
                                <DateInput
                                    value={fecha_embarque}
                                    onChange={(e) => setFechaEmbarque(e.target.value)}
                                />
                            </div>
                            <div className='input-group mb-1'>
                                <span className='input-group-text'>PO</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ingrese PO (opcional)"
                                    value={po}
                                    onChange={(e) => setPo(e.target.value)}
                                />
                            </div>
                            {!po.trim() && (
                                <div className="text-danger small mb-3">PI incompleta: falta informar PO.</div>
                            )}
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>HC</span>
                                <input
                                    type="number"
                                    min="1"
                                    step="1"
                                    className="form-control"
                                    placeholder="Ingrese cantidad de contenedores"
                                    value={hc}
                                    onChange={(e) => setHc(e.target.value)}
                                    required
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Origen</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ingrese Origen"
                                    value={origen}
                                    onChange={(e) => setOrigen(e.target.value)}
                                    required
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Payment Term</span>
                                <select
                                    className="form-control"
                                    value={payment_terms}
                                    onChange={(e) => seleccionPT(e.target.value)}
                                    required
                                >
                                    <option value="">Seleccionar Payment Term</option>
                                    {pt.map(paymentterm => (
                                        <option key={paymentterm.id_paymentterm} value={paymentterm.id_paymentterm}>
                                            {paymentterm.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {indicador4 &&
                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>Advance</span>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Ingrese % advance"
                                        value={advance}
                                        onChange={(e) => setAdvance(e.target.value)}
                                        required
                                    />
                                    <span className='input-group-text'>CAD</span>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Ingrese % CAD"
                                        value={cad}
                                        onChange={(e) => setCAD(e.target.value)}
                                        required
                                    />
                                </div>
                            }
                            <div className="input-group mb-3">
                                <span className='input-group-text'>IncoTerm</span>
                                <select
                                    className="form-select"
                                    value={incoterm}
                                    onChange={(e) => seleccionIT(e.target.value)}
                                >
                                    <option value="">Seleccione un IncoTerm</option>
                                    {incoterms.map((it) => (
                                        <option key={it.id_incoterm} value={it.id_incoterm}>
                                            {it.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text' style={{ width: '160px' }}>Place of Delivery</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Desde dirección despacho del cliente"
                                    value={direccion_despacho}
                                    onChange={(e) => setDireccionDespacho(e.target.value)}
                                />
                            </div>
                            {indicadorIT === 1 &&
                                <div className="input-group mb-3">
                                    <span className='input-group-text'>Puerto</span>
                                    <select
                                        className="form-select"
                                        value={puerto}
                                        onChange={(e) => setPuerto(e.target.value)}
                                    >
                                        <option value="">Seleccione un Puerto de Destino</option>
                                        {puertos.map((puerto) => (
                                            <option key={puerto.id_puerto} value={puerto.id_puerto}>
                                                {puerto.nombre}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            }
                            {indicadorIT === 3 &&
                                <div className='input-group mb-3'>
                                    <span className='input-group-text' style={{ width: '160px' }}>Dirección Despacho</span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Ingrese Dirección"
                                        value={direccion_destino}
                                        onChange={(e) => setDireccionDestino(e.target.value)}
                                        required
                                    />
                                </div>
                            }
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Descripcion Producto</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={descripcion_producto}
                                    disabled
                                />
                            </div>
                            <div className='mb-3'>
                                <h5 style={{ textAlign: 'center' }}>Productos</h5>
                                <div className="mb-3 position-relative" ref={productSearchDropdownRef} style={{ zIndex: 20 }}>
                                    <label className="form-label fw-bold">Selecciona un producto:</label>
                                    <div className="input-group">
                                        <span className="input-group-text"><i className="bi bi-search text-primary"></i></span>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Escribe el nombre de un producto..."
                                            value={productSearchTerm}
                                            onChange={(e) => {
                                                setProductSearchTerm(e.target.value);
                                                setShowProductSearchDropdown(true);
                                            }}
                                            onFocus={() => setShowProductSearchDropdown(true)}
                                            style={{ borderLeft: 'none' }}
                                            disabled={editMode}
                                        />
                                        {productoSeleccionado && !editMode && (
                                            <button
                                                type="button"
                                                className="btn btn-outline-danger"
                                                onClick={() => {
                                                    setProductoSeleccionado(null);
                                                    setProductSearchTerm('');
                                                }}
                                            >
                                                <i className="bi bi-x-circle"></i> Limpiar
                                            </button>
                                        )}
                                        <button
                                            type="button"
                                            className="btn btn-outline-success"
                                            onClick={() => setShowAgregarProducto(true)}
                                            disabled={editMode}
                                        >
                                            Crear Producto
                                        </button>
                                    </div>
                                    {showProductSearchDropdown && !editMode && (
                                        <div
                                            className="list-group position-absolute w-100 shadow-lg"
                                            style={{ zIndex: 1050, maxHeight: '250px', overflowY: 'auto', top: '100%' }}
                                        >
                                            {nombreProductosFiltrados.map((p, idx) => (
                                                <button
                                                    key={`${p.id_producto}-${idx}`}
                                                    type="button"
                                                    className="list-group-item list-group-item-action text-start"
                                                    onClick={() => {
                                                        setProductoSeleccionado(parseInt(p.id_producto, 10));
                                                        setProductSearchTerm(p.nombre_producto);
                                                        setShowProductSearchDropdown(false);
                                                    }}
                                                >
                                                    <span className="fw-medium">{p.nombre_producto}</span>
                                                </button>
                                            ))}
                                            {nombreProductosFiltrados.length === 0 && (
                                                <div className="list-group-item disabled text-muted fst-italic">
                                                    {productSearchTerm.trim()
                                                        ? 'No se encontraron productos coincidentes'
                                                        : 'No hay productos disponibles para este cliente'}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {productoSeleccionado && !editMode && (
                                        <div className="mt-2 p-2 bg-light rounded border-start border-success border-4 d-flex align-items-center">
                                            <i className="bi bi-check-circle-fill text-success me-2" style={{ fontSize: '1.2rem' }}></i>
                                            <div>
                                                <small className="text-muted d-block">Producto seleccionado:</small>
                                                <span className="fw-bold text-success">{productSearchTerm}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="input-group mb-3">
                                    <span className='input-group-text'>m3</span>
                                    <input
                                        type="number"
                                        id="m3"
                                        className="form-control"
                                        value={m3}
                                        onChange={(e) => setM3(e.target.value)}
                                    />
                                    <span className='input-group-text'>{getCurrencySymbol(moneda)}/m3</span>
                                    <input
                                        type="number"
                                        id="usd_m3"
                                        className="form-control"
                                        value={usd_m3}
                                        onChange={(e) => setUsdM3(e.target.value)}
                                    />
                                </div>
                                <button
                                    type="button"
                                    onClick={handleAgregarProducto}
                                    className="btn btn-outline-primary"
                                    disabled={!productoSeleccionado || !m3 || !usd_m3}
                                >
                                    {editMode ? 'Editar Producto' : 'Agregar Producto'}
                                </button>

                                <DataTable
                                    columns={columnsProductos}
                                    data={Productos}
                                    highlightOnHover
                                    dense
                                    pagination={true}
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Valor Proforma (${getCurrencySymbol(moneda)})</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={valor_proforma}
                                    disabled
                                />
                            </div>
                            <div className="input-group mb-3">
                                <span className="input-group-text" style={{ width: '170px' }}>Allowance</span>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Ingrese allowance"
                                    value={allowance}
                                    onChange={(e) => setAllowance(e.target.value)}
                                    required
                                />
                            </div>
                            {indicador1 &&
                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>Beneficiary Bank</span>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        placeholder="Ingrese beneficiary bank"
                                        value={beneficiary_bank}
                                        onChange={(e) => setBeneficiaryBank(e.target.value)}
                                        required
                                    />
                                </div>
                            }
                            {indicador2 &&
                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>Bank Information</span>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        placeholder="Ingrese Información del Banco"
                                        value={bank_information}
                                        onChange={(e) => setBankInformation(e.target.value)}
                                        required
                                    />
                                </div>
                            }
                            {indicador3 &&
                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>Especificaciones Línea de Crédito</span>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        placeholder="Ingrese especificaciones de línea de crédito"
                                        value={especificaciones_lc}
                                        onChange={(e) => setEspecificacionesLC(e.target.value)}
                                        required
                                    />
                                </div>
                            }
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Quality Standards</span>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    placeholder="Ingrese Quality Standards"
                                    value={quality_standards}
                                    onChange={(e) => setQualityStandards(e.target.value)}
                                    required
                                />
                            </div>
                            <div className='mb-3'>
                                <h5 style={{ textAlign: 'center' }}>Documentos Requeridos</h5>
                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>
                                        Documento
                                    </span>
                                    <select
                                        value={nuevoDocumento}
                                        onChange={e => setNuevoDocumento(e.target.value)}
                                        className='form-control'
                                    >
                                        <option value="">Seleccionar Documento</option>
                                        {documentos.map((td) => {
                                            const tdExistente = documentosRequeridos.some(dr => parseInt(dr) === parseInt(td.id_documento));
                                            if (!tdExistente) {
                                                return (
                                                    <option key={td.id_documento} value={td.id_documento}>
                                                        {td.nombre}
                                                    </option>
                                                );
                                            }
                                            return null; // Omitir esta opción si no cumple los requisitos
                                        })}
                                    </select>
                                    <button type="button" onClick={handleAgregarDocumento} className="btn btn-outline-primary" disabled={!nuevoDocumento}>
                                        Agregar Documento
                                    </button>
                                </div>
                                <DataTable
                                    columns={columnsDocumentos}
                                    data={documentosRequeridos}
                                    highlightOnHover
                                    dense
                                    pagination={true}
                                />
                            </div>
                            <div className="input-group mb-3">
                                <span className='input-group-text'>Remitente</span>
                                <select
                                    className="form-select"
                                    value={remitente}
                                    onChange={(e) => setRemitente(e.target.value)}
                                >
                                    <option value="">Seleccione un Remitente</option>
                                    {usuarios.map((user) => (
                                        <option key={user.id_usuario} value={user.id_usuario}>
                                            {user.nombre}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="input-group mb-3">
                                <span className='input-group-text'>Aprobador</span>
                                <select
                                    className="form-select"
                                    value={aprobador}
                                    onChange={(e) => setAprobador(e.target.value)}
                                >
                                    <option value="">Seleccione un Aprobador</option>
                                    {usuarios
                                        .filter(user => user.rol === 1) // Filter users with role 1
                                        .map(user => (
                                            <option key={user.id_usuario} value={user.id_usuario}>
                                                {user.nombre}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Observaciones Proforma</span>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    value={observaciones_proforma}
                                    onChange={(e) => setObservacionesProforma(e.target.value)}
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Observaciones Adicionales</span>
                                <textarea
                                    type="text"
                                    className="form-control"
                                    value={observaciones_adicionales}
                                    onChange={(e) => setObservacionesAdicionales(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className='card-footer' style={{ textAlign: 'center' }}>
                            {estado === 0 &&
                                <div className='mb-3'>
                                    <button
                                        type="button"
                                        className="btn btn-outline-warning mb-3 mt-3"
                                        onClick={(event) => {
                                            setEsBorrador(true); // Marcar como borrador
                                            handleSubmit(event, true);
                                        }}
                                    >
                                        Guardar Como Borrador
                                    </button>
                                </div>
                            }
                            <button
                                type="submit"
                                className="btn btn-outline-success mb-3 mt-3"
                                disabled={botonDeshabilitado}
                                onClick={(event) => {
                                    setEsBorrador(false); // Marcar como finalizado
                                    handleSubmit(event, false);
                                }}
                            >
                                Guardar
                            </button>
                            <button type="button" className="btn btn-outline-danger" onClick={cerrar}>Cancelar</button>
                        </div>
                    </form>
                </div>
            </div>
            <Modal show={showAgregarProducto} onHide={() => setShowAgregarProducto(false)} size="lg" style={{ zIndex: 11000 }}>
                <Modal.Header closeButton>
                    <Modal.Title>Crear Producto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AgregarProducto
                        cerrar={async (nuevo) => {
                            setShowAgregarProducto(false);
                            if (nuevo && nuevo.id_producto) {
                                const productoConTiposCorrectos = {
                                    ...nuevo,
                                    id_producto: parseInt(nuevo.id_producto, 10),
                                    categoria: parseInt(nuevo.categoria, 10),
                                    especie: parseInt(nuevo.especie, 10),
                                    medida: parseInt(nuevo.medida, 10),
                                };
                                setProductosDisponibles((prev) => [...prev, productoConTiposCorrectos]);
                                setIdsProductoExtra((prev) => [
                                    ...prev,
                                    parseInt(productoConTiposCorrectos.id_producto, 10),
                                ]);
                                setProductoSeleccionado(parseInt(productoConTiposCorrectos.id_producto, 10));
                                const lista = await fetchProductNames();
                                const byId = lista.find(
                                    (item) =>
                                        parseInt(item.id_producto, 10) ===
                                        parseInt(productoConTiposCorrectos.id_producto, 10)
                                );
                                setProductSearchTerm(byId?.nombre_producto || '');
                            }
                        }}
                        opciones={{ categorias, especies, calidades, medidas }}
                        medidas={medidas}
                    />
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default EditarProforma
